export default class SubmenuNavigation {

    constructor() {

        this.settings = {
            navLinks: document.querySelectorAll('.small-screen-navigation .navigation__nav-item--has-children'),
            backLinks: document.querySelectorAll('.small-screen-navigation .navigation__nav-item--back'),
            body: document.getElementsByTagName('body')[0],
            activeClass: 'is-active',
            subMenuClass: 'js-sub-nav-open',
        }

    }

    init() {

        if (this.settings.navLinks.length != 0) {
            this.bindUIActions();
        }

    }

    bindUIActions() {

        const { navLinks, backLinks } = this.settings;

        navLinks.forEach(link => {
            if (link.querySelector('button') != undefined) {

                const button = link.querySelector('button');

                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.open_sub_menu(link);
                })

            }
        });

        backLinks.forEach(link => {
            if (link.querySelector('button') != undefined) {

                const button = link.querySelector('button');

                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.close_sub_menu(link);
                })

            }
        })

    }

    //Open submenu
    open_sub_menu(link) {

        const { navLinks, backLinks, body, subMenuClass, activeClass } = this.settings;

        link.querySelector('.navigation__nav-item--sub-menu').classList.add(activeClass);
        link.querySelector('button').setAttribute('aria-expanded', 'true');

        body.classList.add(subMenuClass);

    }

    //Close submenu
    close_sub_menu(link) {

        const { navLinks, backLinks, body, subMenuClass, activeClass } = this.settings;

        let parent = link.parentNode;

        body.classList.remove(subMenuClass);
        link.querySelector('button').setAttribute('aria-expanded', 'false');

        if (parent.classList.contains(activeClass)) {
            parent.classList.remove(activeClass)
        }

    }

}
